import React from 'react';

import { CHAT_ROLE } from '../../../../../constants/assistant';

import MessageWrapper from '../../../../AssistantPage/MessageWrapper/MessageWrapper';

const UserQuery = ({ message }) => {
    const { query } = message;

    return (
        <MessageWrapper role={CHAT_ROLE.user} isSimplifiedVersion>
            <p className="font-body text-body-regular-s text-neutral-500 whitespace-pre-wrap">
                {query}
            </p>
        </MessageWrapper>
    );
};

export default UserQuery;
